/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Build_Focus_ModeInputs */

const en_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build your perfect focus mode`)
};

const ar_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ وضع التركيز المثالي لك`)
};

const de_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie Ihren perfekten Fokusmodus`)
};

const es_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Construye tu modo de concentración perfecto`)
};

const fr_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez votre mode de concentration parfait`)
};

const it_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea la tua modalità di concentrazione perfetta`)
};

const ja_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自分にぴったりの集中モードを設定`)
};

const ko_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`완벽한 집중 모드를 구축하세요`)
};

const pt_br_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie seu modo de foco perfeito`)
};

const ru_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте идеальный режим фокусировки`)
};

const th_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างโหมดการโฟกัสที่สมบูรณ์แบบของคุณ`)
};

const tr_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mükemmel odaklanma modunu oluştur`)
};

const zh_cn_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打造最佳专注模式`)
};

const zh_tw_build_focus_mode = /** @type {(inputs: Build_Focus_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打造最佳專注模式`)
};

/**
* | output |
* | --- |
* | "Build your perfect focus mode" |
*
* @param {Build_Focus_ModeInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const build_focus_mode = /** @type {((inputs?: Build_Focus_ModeInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Build_Focus_ModeInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_build_focus_mode(inputs)
	if (locale === "ar") return ar_build_focus_mode(inputs)
	if (locale === "de") return de_build_focus_mode(inputs)
	if (locale === "es") return es_build_focus_mode(inputs)
	if (locale === "fr") return fr_build_focus_mode(inputs)
	if (locale === "it") return it_build_focus_mode(inputs)
	if (locale === "ja") return ja_build_focus_mode(inputs)
	if (locale === "ko") return ko_build_focus_mode(inputs)
	if (locale === "pt_br") return pt_br_build_focus_mode(inputs)
	if (locale === "ru") return ru_build_focus_mode(inputs)
	if (locale === "th") return th_build_focus_mode(inputs)
	if (locale === "tr") return tr_build_focus_mode(inputs)
	if (locale === "zh_cn") return zh_cn_build_focus_mode(inputs)
	return zh_tw_build_focus_mode(inputs)
});